import React from "react";
import { fallbackValues } from "./Icons.theme";
import { themeComponent } from "../../../util/themeUtils";

const ProfileIconSmall = ({ themeValues }) => {
  return (
    <svg
      width="31px"
      height="31px"
      viewBox="0 0 31 31"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Random-Icon-Work"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Header/Desktop/Menu"
          fill={themeValues.singleIconColor}
          fillRule="nonzero"
        >
          <g id="My-profile">
            <path
              d="M15.0155892,30.3906169 C17.7200101,30.3906169 20.222608,29.7145114 22.5233838,28.3623014 C24.8241596,27.0100914 26.6506529,25.1835981 28.0028629,22.8828223 C29.3550729,20.5820466 30.0311784,18.0794487 30.0311784,15.3750277 C30.0311784,12.6706068 29.3550729,10.1680089 28.0028629,7.86723312 C26.6506529,5.56645735 24.8241596,3.739964 22.5233838,2.38775399 C20.222608,1.03554398 17.7200101,0.359438516 15.0155892,0.359438516 C12.3111683,0.359438516 9.80857036,1.03554398 7.5077946,2.38775399 C5.20701884,3.739964 3.38052549,5.56645735 2.02831548,7.86723312 C0.676105467,10.1680089 0,12.6706068 0,15.3750277 C0,18.0794487 0.676105467,20.5820466 2.02831548,22.8828223 C3.38052549,25.1835981 5.20701884,27.0100914 7.5077946,28.3623014 C9.80857036,29.7145114 12.3111683,30.3906169 15.0155892,30.3906169 Z M15.0155892,16.8281493 C13.5624677,16.8281493 12.3111683,16.3034106 11.2616919,15.2539343 C10.2122155,14.2044579 9.6874769,12.9531585 9.6874769,11.500037 C9.6874769,10.0469154 10.2122155,8.79561601 11.2616919,7.74613965 C12.3111683,6.6966633 13.5624677,6.17192466 15.0155892,6.17192466 C16.4687107,6.17192466 17.7200101,6.6966633 18.7694865,7.74613965 C19.8189629,8.79561601 20.3437015,10.0469154 20.3437015,11.500037 C20.3437015,12.9531585 19.8189629,14.2044579 18.7694865,15.2539343 C17.7200101,16.3034106 16.4687107,16.8281493 15.0155892,16.8281493 Z M15.0155892,27 C13.2799159,27 11.6350637,26.6367196 10.0810307,25.9101588 C8.52699759,25.1835981 7.20506095,24.1744856 6.1152198,22.8828223 C6.7206871,21.7929812 7.5481594,20.9150536 8.59763575,20.2490395 C9.64711211,19.5830255 10.8176828,19.2500185 12.1093461,19.2500185 C12.2304396,19.2500185 12.371715,19.2702004 12.5331732,19.3105652 C13.3808275,19.5931169 14.2082998,19.7343923 15.0155892,19.7343923 C15.8228786,19.7343923 16.6503509,19.5931169 17.4980052,19.3105652 C17.6594634,19.2702004 17.8007388,19.2500185 17.9218323,19.2500185 C19.2134956,19.2500185 20.3840663,19.5830255 21.4335426,20.2490395 C22.483019,20.9150536 23.3104913,21.7929812 23.9159586,22.8828223 C22.8261175,24.1744856 21.5041808,25.1835981 19.9501477,25.9101588 C18.3961147,26.6367196 16.7512625,27 15.0155892,27 Z"
              id="user-circle"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default themeComponent(
  ProfileIconSmall,
  "Icons",
  fallbackValues,
  "primary"
);
